var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEmail = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M49.27 20.9a2.195 2.195 0 0 0-2.2-2.11H16.98c-1.18 0-2.15.93-2.2 2.11-.35 8.1-.2 13.25.04 21.05l.03 1.12c.04 1.2 1 2.14 2.19 2.14l30.01-.02c1.2 0 2.16-.94 2.19-2.13.08-3.14.33-14 .01-22.17Zm-2.35 19.49-8.75-8.75 8.78-8.45c.16 6.09.06 13.1-.02 17.2Zm-29.8-17.82 8.29 9.5-8.23 8.23c-.19-6.4-.3-11.12-.06-17.73Zm14.79 11.76c-.41.27-.94.27-1.34 0L19.1 21.19h26.46L31.91 34.33Zm-4.92-.45L28.84 36l.16.15c.66.52 1.45.79 2.25.79s1.52-.24 2.16-.72l3.03-2.92 9.49 9.49H18.06l8.92-8.91Z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export default ForwardRef;